import type { Product } from '@/api/getProductList'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './PriceCard.module.css'

interface PriceCardProps {
  isSelected: boolean
  data: Product
  onSelect: (id: number) => void
}

const PriceCard: React.FC<PriceCardProps> = ({ isSelected, data, onSelect }) => {
  const handleClick = () => {
    onSelect(data.id)
  }

  const discountPrice = data.ftPrice
    ? parseInt(String(((data.originalPrice - data.ftPrice) / data.originalPrice) * 100))
    : parseInt(String(((data.originalPrice - data.discountPrice) / data.originalPrice) * 100))

  const { t, i18n } = useTranslation()
  // alert(i18n.language)
  return (
    <div onClick={handleClick} className={`w-full ${styles.priceCard} ${isSelected ? styles.selected : ''}`}>
      {/* 折扣标签 */}

      {data.ftPrice ? (
        <div className={'text-[0.65rem] ' + styles.label}>
          {t('home.firstBuy')}
          {discountPrice}%
        </div>
      ) : (
        <div className={'text-[0.65rem] ' + styles.label}>
          {t('home.discountPrice')}
          {discountPrice}%
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.contentInner}>
          {/* 会员周期 */}
          <div className={styles.period}>{data.productName[i18n.language as 'zh' | 'en' | 'ko' | 'vi']}</div>

          {/* 折扣价 */}
          <div className={styles.discountPrice}>
            <span>¥</span>
            <strong>{data.ftPrice ?? data.discountPrice}</strong>
          </div>

          {/* 原价 */}
          <div className={styles.originalPrice}>¥{data.originalPrice}</div>

          {/* 赠送 */}
          {data.trialCardInfo ? (
            <div className={styles.gift}>
              {t('home.Gift', { day: data.trialCardInfo.experienceDays, amount: data.trialCardInfo.count })}
            </div>
          ) : (
            <div className={styles.gift}>{t('home.noGift')}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PriceCard
